import { useEffect, useState } from "react";
import { Clock3 } from "lucide-react";
import { tzNameOf } from "./work/WorkModals";

function tzOffsetMinutes(timeZone: string, date: Date): number {
  try {
    const dtf = new Intl.DateTimeFormat("en-US", {
      timeZone,
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    const parts = Object.fromEntries(
      dtf.formatToParts(date).map((part) => [part.type, part.value])
    ) as Record<string, string>;
    const asUTC = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour) % 24,
      Number(parts.minute),
      Number(parts.second)
    );
    return Math.round((asUTC - date.getTime()) / 60_000);
  } catch {
    return 0;
  }
}

/** 客户所在地动态时间（每分钟刷新） */
export function ClientTime({ country }: { country: string }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(timer);
  }, []);

  const tz = tzNameOf(country);
  if (!tz) return null;

  const local = now.toLocaleTimeString("zh-CN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: tz
  });
  const offset = tzOffsetMinutes(tz, now) - tzOffsetMinutes("Asia/Shanghai", now);
  const diffText =
    offset === 0 ? "与北京同时区" : `比北京${offset > 0 ? "快" : "慢"} ${Math.abs(offset / 60)} 小时`;

  return (
    <span className="client-time" title={`${country} · ${diffText}`}>
      <Clock3 size={13} />
      {country} {local}
      <small>{diffText}</small>
    </span>
  );
}
